module.exports = __webpack_public_path__ + "svg/eye.svg?4bf55fd29659d7d2b293946f0a6b453a";